import { Injectable } from '@angular/core'
import { CultureIndexJobPostsService } from '@employer/app/modules/jobs/services/culture-index-job-posts.service'
import { JobPostApplicationRepository } from '@employer/app/repositories/job-post-application.repository'
import { IFileReceipt } from '@engineering11/files-web'
import { FieldValue } from '@engineering11/web-api-firebase'
import { APPLICATION_STATE, IRequestedActions, IRequestedUpdate, RequestedAction } from 'shared-lib'

@Injectable({ providedIn: 'root' })
export class JobPostApplicationService {
  constructor(public repository: JobPostApplicationRepository, private cultureIndexJobPostsService: CultureIndexJobPostsService) {}

  getApplications(jobPostId: string) {
    return this.repository.getAllValueChanges(jobPostId)
  }

  getApplicationsByStatusInfiniteScroll(jobPostId: string, status: APPLICATION_STATE, limit = 100) {
    return this.repository.getAllValueChangesByStatus(jobPostId, status, limit)
  }

  getAllApplicationsInfiniteScroll(jobPostId: string, limit = 100) {
    return this.repository.getAllValueChangesInfiniteScroll(jobPostId, limit)
  }

  getApplicationsCountByStatus(jobPostId: string, status: APPLICATION_STATE) {
    return this.repository.getCountByStatus(jobPostId, status)
  }

  addRequestedUpdate(jobPostId: string, applicationId: string, requestedUpdate: IRequestedUpdate[]) {
    return this.repository.update({ id: applicationId, jobPostId, requestedUpdated: FieldValue.arrayUnion(...requestedUpdate) })
  }
  async addRequestedAction(jobContentId: string, jobPostId: string, applicationId: string, requestedAction: IRequestedActions) {
    if (requestedAction.requestedAction == RequestedAction.CultureIndex) {
      return await this.cultureIndexJobPostsService.requestSurvey(jobContentId, applicationId)
    } else {
      return this.repository.update({ id: applicationId, jobPostId, requestedActions: FieldValue.arrayUnion(...[requestedAction]) })
    }
  }

  addConversationId(jobPostId: string, applicationId: string, conversationId: string) {
    return this.repository.update({ id: applicationId, jobPostId, conversationId })
  }

  addApplicationFiles(jobPostId: string, applicationId: string, applicationFiles: IFileReceipt[]) {
    return this.repository.update({ id: applicationId, jobPostId, applicationFiles })
  }

  removeApplicationFiles(jobPostId: string, applicationId: string, applicationFiles: IFileReceipt[]) {
    return this.repository.update({ id: applicationId, jobPostId, applicationFiles: FieldValue.arrayRemove(...applicationFiles) })
  }
}
